define( function() {
	"use strict";

	return [];
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/arr.js
// module id = 110
// module chunks = 1